import { render, staticRenderFns } from "./BrakeListItem.vue?vue&type=template&id=0af1d511"
import script from "./BrakeListItem.vue?vue&type=script&lang=js"
export * from "./BrakeListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports